module.exports = __webpack_public_path__ + "img/lhb.5c163cc9.svg";